import React from 'react';
import treatment from '../../../assets/images/treatment.png'

const Treatment = () => {
    return (
        <div>
            <div className="card lg:card-side bg-base-100 shadow-xl my-5 lg:mx-auto">
                <figure><img src={treatment} className="h-full w-1/2 rounded-xl" alt="Album" /></figure>
                <div className="card-body w-1/2 mx-auto">
                    <h2 className="card-title  mt-5 lg:text-5xl">Exceptional Dental Care, on Your Terms!</h2>
                    <p className='w-full'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsumis that it has a more-or-less normal distribution of letters,as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page.</p>
                    <div className="card-actions justify-end">
                    <button className="btn btn-accent text-white">Get Started</button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Treatment;